import { FormInput } from '../ui/FormInput';
import { MeetingTypeSelect } from '../ui/MeetingTypeSelect';
import { SpeakerSelect } from '../ui/SpeakerSelect';
import { Report } from '../../types/report';

interface GeneralInfoProps {
  onChange: (section: keyof Report, data: any) => void;
  initialData: Partial<Report>;
}

export default function GeneralInfo({ onChange, initialData }: GeneralInfoProps) {
  const handleChange = (field: string, value: string) => {
    // Convert messageTheme to uppercase
    if (field === 'messageTheme') {
      onChange(field as keyof Report, { [field]: value.toUpperCase() });
    } else {
      onChange(field as keyof Report, { [field]: value });
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
      <h2 className="text-lg font-semibold text-gray-800 mb-6">Informations générales</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <MeetingTypeSelect
          value={initialData.meetingTypeId || ''}
          onChange={(value) => handleChange('meetingTypeId', value)}
          required
        />
        <FormInput
          label="Nom de la Cellule"
          value={initialData.cellName || ''}
          onChange={(e) => handleChange('cellName', e.target.value)}
          required
        />
        <FormInput
          label="Église Source"
          value={initialData.sourceChurch || ''}
          onChange={(e) => handleChange('sourceChurch', e.target.value)}
          required
        />
        <FormInput
          label="Date du culte"
          type="date"
          value={initialData.date || ''}
          onChange={(e) => handleChange('date', e.target.value)}
          required
        />
        <SpeakerSelect
          value={initialData.speakerId || ''}
          onChange={(value) => handleChange('speakerId', value)}
          required
        />
        <div className="md:col-span-2">
          <FormInput
            label="Thème du message"
            placeholder="ex: La puissance de la foi"
            value={initialData.messageTheme || ''}
            onChange={(e) => handleChange('messageTheme', e.target.value)}
            required
          />
        </div>
        <div className="md:col-span-2">
          <FormInput
            label="Source du message"
            placeholder="ex: Matthieu 17:20"
            value={initialData.messageSource || ''}
            onChange={(e) => handleChange('messageSource', e.target.value)}
            required
          />
        </div>
      </div>
    </div>
  );
}